import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';

import SectionCard from '../../../positionTemplate/components/SectionCard';
import {
  BENEFITS_PACKAGE_OPTIONS,
  BRANCH_OPTIONS,
  LEGAL_BUSINESS_ENTITY_OPTIONS,
  PAY_GROUP_OPTIONS,
} from '../../constants';
import AutoSaveSelectField from '../AutoSaveSelectField';
import AutoSaveTextField from '../AutoSaveTextField';
import SectionTitle from '../SectionTitle';

const contentSx = {
  display: 'grid',
  gap: '16px',
  gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
  padding: '8px 0',
};

const SELECT_FIELDS = [
  {
    field: 'branch',
    labelId: 'page.positionTemplateDetail.branch.label',
    options: BRANCH_OPTIONS,
  },
  {
    field: 'legalBusEntry',
    labelId: 'page.positionTemplateDetail.legalBusEntry.label',
    options: LEGAL_BUSINESS_ENTITY_OPTIONS,
  },
  {
    field: 'benefitsPack',
    labelId: 'page.positionTemplateDetail.benefitsPack.label',
    options: BENEFITS_PACKAGE_OPTIONS,
  },
  {
    field: 'payGroup',
    labelId: 'page.positionTemplateDetail.payGroup.label',
    options: PAY_GROUP_OPTIONS,
  },
];

const AdditionalDetailsCard = ({ positionTemplate, saveField, getStatus }) => {
  const intl = useIntl();
  const t = (id) => intl.formatMessage({ id });

  const save = (field, value) =>
    saveField({ key: field, fields: { [field]: value }, patch: { [field]: value } });

  return (
    <SectionCard header={<SectionTitle>{t('pt.detail.additionalDetails')}</SectionTitle>}>
      <Box sx={contentSx}>
        {SELECT_FIELDS.map(({ field, labelId, options }) => (
          <AutoSaveSelectField
            key={field}
            id={`pt-detail-${field}`}
            label={t(labelId)}
            value={positionTemplate[field]}
            options={options}
            placeholder={t('pt.detail.additionalDetails.select')}
            status={getStatus(field)}
            onSave={(value) => save(field, value)}
          />
        ))}
        <AutoSaveTextField
          id="pt-detail-saleRep"
          label={t('pt.detail.summary.salesRep')}
          value={positionTemplate.saleRep}
          status={getStatus('saleRep')}
          onSave={(saleRep) => save('saleRep', saleRep.trim())}
        />
      </Box>
    </SectionCard>
  );
};

AdditionalDetailsCard.propTypes = {
  positionTemplate: PropTypes.shape({
    branch: PropTypes.string,
    legalBusEntry: PropTypes.string,
    benefitsPack: PropTypes.number,
    payGroup: PropTypes.string,
    saleRep: PropTypes.string,
  }).isRequired,
  saveField: PropTypes.func.isRequired,
  getStatus: PropTypes.func.isRequired,
};

export default AdditionalDetailsCard;
